<template>
  <card-seplag titulo="FILTROS DE PESQUISA">
    <Dialog header="Excluir vínculo entre escolas e DRE" :visible.sync="exibirModalEscolasDre" :modal="true"
      :closable="false" >
      <div class="p-col-12">
        <DataTable :value="listaEscolasDre" :paginator="true" :rows="10"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 20, 50]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          selectionMode="multiple">
          <Column field="codSeap" header="SEAP"></Column>
          <Column field="descUnidade" header="UNIDADE"></Column>
          <Column field="descDre" header="DRE"></Column>
        </DataTable>
        <p>Deseja realmente cancelar esse setor como uma DRE? Todos os vínculos serão desfeitos </p>
        <div class="p-col-12 p-md-2" style="float: left; text-align: right; ">
          <Button label="Sim" class="p-button-danger" icon="pi pi-check" @click="excluirEscolas" />
        </div>
        <div class="p-col-12 p-md-2" style="float: left; text-align: right; ">
          <Button label="Nao" class="p-button-info" icon="pi pi-times" @click="carregarDados" />
        </div>
      </div>
    </Dialog>
    <div style="display: flex;">
      <Rotulo cols="12 8" nome="SETOR">
        <InputText v-model="searchQuery" type="text" placeholder="Digite sua pesquisa..." @input="search" />
      </Rotulo>
      <Rotulo cols="12 4">
        <Button label="Pesquisar" style="margin-left: 10px; margin-top: 16.5px;" @click="search" />
      </Rotulo>
    </div>

    <div class="p-col-12" v-if="listaSetor.length > 0">
      <h1> LISTA DOS SETORES </h1>
    </div>

    <div class="p-col-12 divTabelaSetor" v-if="listaSetor.length > 0">
      <DataTable :value="listaSetor" :paginator="true" :rows="10"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        selectionMode="multiple">
        <Column field="codSeap" header="SEAP"></Column>
        <Column field="descUnidade" header="SETOR"></Column>
        <Column header="SELECIONADOS" headerStyle="width:7%;" :bodyStyle="'text-align: center;'">
          <template #body="slotProps">
            <Checkbox :value="slotProps.data" v-model="setorSelecionados" :disabled="desabilitarAlteracao" />
          </template>
        </Column>
      </DataTable>
    </div>

    <div class="p-col-12 p-md-2" style="float: right; text-align: right; ">
      <Button label="Salvar" class="p-button-success" icon="pi pi-save" @click="salvarDRE" />
    </div>
  </card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import { baseApiUrl } from '@/config/global'


export default {
  name: 'setorDRE',
  components: { CardSeplag, Rotulo },
  data() {
    return {
      desabilitarAlteracao: false,
      listaSetor: [],
      setorSelecionados: [],
      setorSelecionadosOld: [],
      searchQuery: '',

      //modal exibirModalEscolasDre
      listaEscolasDre: [],
      exibirModalEscolasDre: false,
    }
  },
  async created() {
    await this.carregarDados();
  },
  methods: {
    async carregarDados() {
      this.listaEscolasDre = [];
      this.exibirModalEscolasDre = false;
      try {
        const res = await this.$http.get(`${baseApiUrl}/dre/load`);
        this.listaSetor = res.data;
        this.setorSelecionadosOld = this.listaSetor.filter(item => item.selecionado);
        this.setorSelecionados = this.listaSetor.filter(item => item.selecionado);
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      }
    },
    async salvarDRE() {
      const dreExcluir = [];
      this.setorSelecionados.forEach(setor => setor.selecionado = true);
      this.setorSelecionadosOld.forEach(setorOld => {
        const exists = this.setorSelecionados.some(setor => setor.id === setorOld.id);
        if (!exists) {
          setorOld.selecionado = false;
          this.setorSelecionados.push(setorOld);
          dreExcluir.push(setorOld);
        }
      });
      if (dreExcluir.length > 0) {
        for (const dre of dreExcluir) {
          const response = await this.$http.get(`${baseApiUrl}/escolaDre/selecionadas/${dre.id}`);
          response.data.forEach(response => response.selecionado=false)
          this.listaEscolasDre.push(...response.data);          
        }
        if(this.listaEscolasDre.length > 0){
          console.log(this.listaEscolasDre);
          this.exibirModalEscolasDre = true;
        }else{
          this.excluirIncluirDRE();
        }
        
      } else {
        this.excluirIncluirDRE();        
      }
    },
    async excluirEscolas(){
      const res = await this.$http.post(`${baseApiUrl}/escolaDre/atualizarEscolaDre`, JSON.stringify(this.listaEscolasDre));
        this.$toast.add({ severity: 'success', summary: 'Ação Efetuada', detail: res.data, life: 5000 });                
        this.excluirIncluirDRE();
        await this.carregarDados();
    },
    async excluirIncluirDRE() {
      const res = await this.$http.post(`${baseApiUrl}/dre/atualizarDre`, JSON.stringify(this.setorSelecionados));
      this.$toast.add({ severity: 'success', summary: 'Ação Efetuada', detail: res.data, life: 5000 });
      await this.carregarDados();
    },
    async search() {
      if (this.searchQuery === '') {
        await this.carregarDados();
      } else {
        try {
          const res = await this.$http.get(`${baseApiUrl}/dre/pesquisa/${this.searchQuery}`);
          this.listaSetor = res.data;
          this.setorSelecionadosOld = this.listaSetor.filter(item => item.selecionado);
          this.setorSelecionados = this.listaSetor.filter(item => item.selecionado);
        } catch (error) {
          console.error("Erro na pesquisa:", error);
        }
      }
    }
  },
  mounted() {

  }
}
</script>
<style scoped></style>